import { Box, Button, Typography } from '@mui/material';
import { roomJoinRequest } from 'features/room/actions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import { selectAwaitingRoomJoin } from 'features/room/roomSlice';
import AwaitingRoomJoin from 'features/join/shared/AwaitingRoomJoin';
import { styleConstants } from 'theme/styleConstants';
import { useJoinActionKeyboardShortcut } from 'features/join/hooks/useJoinActionKeyboardShortcut';
import { useCallback } from 'react';

const AUTOPLAY_NOTICE_ID = 'fast-join-autoplay-notice';

const FastJoinAudience = () => {
  const { t } = useTranslation('join');
  const dispatch = useAppDispatch();

  const awaitingRoomJoin = useAppSelector(selectAwaitingRoomJoin);

  const handleJoin = useCallback(() => {
    dispatch(roomJoinRequest());
  }, [dispatch]);

  useJoinActionKeyboardShortcut({
    onJoin: handleJoin,
    disabled: !!awaitingRoomJoin,
  });

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      {awaitingRoomJoin ? (
        <AwaitingRoomJoin />
      ) : (
        <Box
          sx={{
            width: '100%',
            maxWidth: styleConstants.narrowContainerWidth,
          }}
        >
          <Typography
            id={AUTOPLAY_NOTICE_ID}
            sx={{
              mb: 4,
              textAlign: 'center',
            }}
          >
            {t('fast_join.autoplay_notice')}
          </Typography>
          <Button
            type="button"
            variant="contained"
            fullWidth
            aria-describedby={AUTOPLAY_NOTICE_ID}
            onClick={handleJoin}
          >
            {t('fast_join.btn_label_proceed')}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default FastJoinAudience;
